<template lang="pug">
    article#home
        Banner
        Experiencia
        Page
        Extra
        Formulario
</template>

<script>
import Banner from '@sections/Home/Banner/Banner.vue'
import Experiencia from '@sections/Home/Experiencia/Experiencia.vue'
import Page from '@sections/Home/Page/Page.vue'
import Extra from '@sections/Home/Extra/Extra.vue'
import Formulario from '@sections/Home/Formulario/Formulario.vue'

export default {
    name: "home",
    components: {
        Banner,
        Experiencia,
        Page,
        Extra,
        Formulario,
    },
    mounted() {
        this.$eventBus.$on('openExperiencia', this.openExperiencia)
        this.$eventBus.$on('goTo', this.goTo)

        if (this.$route.hash.toUpperCase().includes('FAELFLIX'))
            this.$eventBus.$emit('openExperiencia', 'faelflix')
        else if (this.$route.hash.toUpperCase().includes('FAELPLUS'))
            this.$eventBus.$emit('openExperiencia', 'faelPlus')
    },
    methods: {
        goTo(target) {
            document.querySelector(target).scrollIntoView({
                behavior: 'smooth'
            });  
        },
        openExperiencia(secao) {
            if (secao == 'faelPlus')
                this.$eventBus.$emit('setDragPosition', {
                    markerPosition: window.innerWidth,
                    imagePosition: 0,
                    direction: 'right'
                })
            else 
                this.$eventBus.$emit('setDragPosition', {
                    markerPosition: 0,
                    imagePosition: 100,
                    direction: 'left'
                })
            
            setTimeout(() => {
                this.$eventBus.$emit('goTo', `#${secao}`)
            }, 500)
        }
    },
}
</script>

<style lang="stylus" scoped src="@views/Home/Home.styl"></style>